<div>
  <div style="margin-bottom: 5px">
    <p-toolbar>
      <ng-template pTemplate="start">
        <p-splitButton
          *ngIf="showNewButton"
          label="New"
          class="mr-2 yellowbutton"
          [model]="newButtonOptions"
          (onClick)="newButtonAction()"
        />
        <p-multiSelect
          [options]="cols"
          [(ngModel)]="selectedColumns"
          optionLabel="header"
          defaultLabel="columns"
          selectedItemsLabel="columns"
          [maxSelectedLabels]="0"
          (onChange)="onColumnChange($event)"
          class="mr-2"
        ></p-multiSelect>
        <p-button
          icon="fa fa-filter"
          label="clear all"
          class="mr-2 whitebutton"
          (onClick)="clearFilters()"
        />
        <div
          class="shadow"
          style="display: flex; overflow-x: auto; white-space: nowrap; width: 400px"
        >
          <p-chip
            *ngFor="let filter of dictToArr(filters)"
            [label]="fieldToLabel(filter)"
            class="mr-2"
            [removable]="true"
            (onRemove)="clearFilter(filter)"
          />
        </div>
      </ng-template>
      <ng-template pTemplate="center"> </ng-template>
      <ng-template pTemplate="end">
        <div>Selected: {{ selectfilterQuantity }}</div>
        <p-button
          *ngIf="showLeftButton"
          icon="pi pi-arrow-left"
          class="ml-2 yellowbutton"
          [disabled]="selectfilterQuantity <= 0 && !isSelectAllClicked"
          (onClick)="onClickLeftArrow()"
          tooltipPosition="left"
          [pTooltip]="leftArrowText"
        />
        <div *ngIf="rightArrowText == 'Run Billing Cycle Now'">
          <p-button
            *ngIf="showRightButton"
            icon="pi pi-arrow-right"
            class="ml-2 bluebutton"
            [disabled]="selectfilterQuantity <= 0 && !isSelectAllClicked"
            (onClick)="onClickRightArrow()"
            tooltipPosition="left"
            [pTooltip]="rightArrowText"
          />
        </div>
        <div *ngIf="rightArrowText != 'Run Billing Cycle Now'">
          <p-button
            *ngIf="showRightButton"
            icon="pi pi-arrow-right"
            class="ml-2 yellowbutton"
            [disabled]="selectfilterQuantity <= 0 && !isSelectAllClicked"
            (onClick)="onClickRightArrow()"
            tooltipPosition="left"
            [pTooltip]="rightArrowText"
          />
        </div>
        <p-button
          *ngIf="showPrintInvoice"
          icon="fa fa-print"
          class="ml-2 yellowbutton"
          [disabled]="selectfilterQuantity <= 0 && !isSelectAllClicked"
          (onClick)="printInvoices()"
          title="PRINT INVOICES"
        />
        <p-button
          *ngIf="showExcelButton"
          icon="fa fa-file-excel-o"
          class="ml-2"
          severity="success"
          (onClick)="excelGeneration()"
          title="GENERATE EXCEL"
        />
        <p-button
          *ngIf="showEmailButton"
          icon="fa fa-envelope"
          label="Email Selected"
          class="ml-2 btn-secondary"
          [disabled]="selectfilterQuantity <= 0 && !isSelectAllClicked"
          (onClick)="emailSelectedTrips()"
          title="Send email to drivers of selected trips"
        />
      </ng-template>
    </p-toolbar>
  </div>
  <p-table
    #dt
    [columns]="selectedColumns"
    [value]="data"
    (onSort)="onSort($event)"
    [paginator]="true"
    [rows]="rows"
    [first]="first"
    (onPage)="onPageChange($event)"
    (onStateRestore)="onStateRestore()"
    [reorderableColumns]="true"
    (onColReorder)="saveColumnOrdering($event)"
    [rowsPerPageOptions]="rowsOptions"
    [totalRecords]="totalRecords"
    [loading]="isLoading"
    stateStorage="local"
    stateKey="{{ pageName }}"
  >
    <ng-template pTemplate="emptymessage" let-cols>
      <tr>
        <td [attr.colspan]="cols.length">No records found</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="colgroup" let-cols>
      <colgroup>
        <col />
        <col *ngFor="let col of selectedColumns" />
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-cols>
      <tr>
        <th>
          <div align="center">
            <p-checkbox
              binary="true"
              [(ngModel)]="selectAll"
              (onChange)="selectAllTripsChanged($event.checked)"
            ></p-checkbox>
          </div>
        </th>
        <th
          *ngFor="let col of selectedColumns"
          pReorderableColumn
          [pSortableColumn]="col.field"
          [title]="col.header"
        >
          {{ col.header }}
          <!-- <p-sortIcon *ngIf="col.header.length" [field]="col.field"></p-sortIcon> -->
          <i
            class="pi"
            [ngClass]="{
              'pi-sort-up': sortField !== col.field || sortOrder === null,
              'pi-angle-up': sortField === col.field && sortOrder === 1,
              'pi-angle-down': sortField === col.field && sortOrder === -1,
            }"
            [ngStyle]="{
              visibility: sortField !== col.field || sortOrder === null ? 'hidden' : 'visible',
            }"
          ></i>
        </th>
      </tr>
      <tr>
        <th></th>
        <th *ngFor="let col of selectedColumns" [ngSwitch]="col.field">
          <select
            *ngIf="isFilterable(col.field) && col.type === 'boolean'"
            class="filter-select"
            (change)="onFilterInput(col.field, $event)"
            [(ngModel)]="filters[col.field]"
          >
            <option value=""></option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          <input
            *ngIf="isFilterable(col.field) && col.type !== 'date' && col.type !== 'boolean'"
            type="text"
            style="width: 100%; font-size: 12px"
            (input)="onFilterInput(col.field, $event)"
            [(ngModel)]="filters[col.field]"
          />
          <div
            *ngIf="isFilterable(col.field) && col.type === 'date'"
            style="display: flex; gap: 2px"
          >
            <input
              type="date"
              style="width: 49%; font-size: 12px"
              (input)="onDateRangeChange(col.field + '_from', $event, true)"
              [(ngModel)]="filters[col.field + '_from']"
              placeholder="From"
            />
            <input
              type="date"
              style="width: 49%; font-size: 12px"
              (input)="onDateRangeChange(col.field + '_to', $event, false)"
              [(ngModel)]="filters[col.field + '_to']"
              placeholder="To"
            />
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
      <tr class="clickable-row" (dblclick)="onDblClick(data)" style="height: 42px">
        <td>
          <div align="center">
            <p-checkbox
              binary="true"
              [(ngModel)]="data.selected"
              (onChange)="selectionChanged($event, data)"
            ></p-checkbox>
          </div>
        </td>
        <td
          *ngFor="let col of selectedColumns"
          [ngStyle]="{
            'text-align':
              col.type === 'number' || col.type === 'currency' || col.type === 'percent'
                ? 'right'
                : 'left',
          }"
        >
          <span
            *ngIf="col === selectedColumns[0] && data.activeUsers?.length > 0"
            class="active-users-badge"
            [pTooltip]="data?.activeUsersTooltip"
          >
            <i class="fa fa-users"></i> {{ data.activeUsers?.length }}
          </span>

          <!-- Custom column template overrides default type-based rendering -->
          <ng-container *ngIf="columnTemplates[col.field]; else cellByType">
            <ng-container
              *ngTemplateOutlet="
                columnTemplates[col.field];
                context: { $implicit: data, column: col }
              "
            ></ng-container>
          </ng-container>

          <ng-template #cellByType>
            <span *ngIf="!col.type">
              {{ data[col.field] }}
            </span>
            <span
              *ngIf="col.type === 'boolean'"
              class="boolean-pill"
              [ngClass]="data[col.field] ? 'boolean-true' : 'boolean-false'"
            >
              {{ data[col.field] ? "Yes" : "No" }}
            </span>
            <span *ngIf="col.type === 'date'">
              {{ toDate(data[col.field])?.toLocaleDateString() }}
            </span>
            <span *ngIf="col.type === 'number'">
              {{ data[col.field] | number: "1.0" : "en-US" }}
            </span>
            <span *ngIf="col.type === 'currency'">{{ data[col.field] | currency }}</span>
            <span *ngIf="col.type === 'percent'">{{ data[col.field] | number: "1.2-2" }}%</span>
            <span *ngIf="col.type === 'name'">{{ data["driverNameReversed"] }}</span>
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
